
module.exports =  function() {
 var defaults = require('../config/defaults')();
 return this.initOptions(defaults, this.globalOptions, this.options);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/opts.js